<div class="row mt-5">
    <div class="col text-center">
        <div>
            <label for="" class="h3">It looks like this link has been modified. Please rescan the QR code!
            </label>
        </div>

    </div>
</div>